<template>
  <div :class="['conter', bAntmain ? 'onmagin' : 'nomagin']" v-if="bShowEnd">
    <div class="conter_warp">
      <div class="title_xiao">末端设备选型</div>
      <div
        class="rooms_list"
        v-for="(item, index) in reporInfo.sub"
        :key="index"
      >
        <div class="room">{{ item.room | roomNumber }}</div>
        <div
          class="shopp_warp"
          v-for="(sumitem, sumindex) in item.rooms"
          v-show="sumitem.product.length"
          :key="sumindex"
        >
          <div class="room_name">
            <div>{{ sumitem.name }}</div>
            <div
              :class="['tips_icon', sumitem.open ? '' : 'openClass']"
              @click="getOpen(index, sumindex)"
            >
              {{ sumitem.open ? "收起详情" : "展开详情" }}
            </div>
          </div>
          <div :class="['shopp_conter']">
            <div class="shopp_room_aeit">
              <div class="situat_item">
                <span class="label">面积</span>
                <span class="room_type">{{ sumitem.area + "m²" }}</span>
              </div>
              <div class="situat_item">
                <span class="label">朝向</span>
                <span class="room_type">{{ sumitem.direction | towards }}</span>
              </div>
            </div>
            <div class="shopp_title">末端设备配置</div>
            <div>
              <div
                :class="['end_shopp', sumitem.open ? '' : 'actOpenBorder']"
                v-for="(sopitem, sopindex) in sumitem.product"
                :key="sopindex"
              >
                <div class="end_shopp_name">
                  <div>{{ sopitem.new_goods_type_name }}</div>
                  <div class="end_type">{{ sopitem.goods_name }}</div>
                </div>
                <div class="end_shopp_warp">
                  <div class="shopp_img">
                    <img v-lazy="sopitem.mobile_img" alt="" />
                  </div>
                  <div class="shopp_attr">
                    <div
                      v-for="(attritem, attrindex) in sopitem.attr_three"
                      :key="attrindex"
                    >
                      <span>{{ attritem.attr_name }}</span>
                      <span>{{ attritem.attr_value }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- type -->
            <div :class="['selection', sumitem.open ? '' : 'actOpen']">
              <div class="selection_conter">
                <div class="situat_item">
                  <span class="label">层高</span>
                  <span class="room_type">{{ sumitem.floor + "m" }}</span>
                </div>
                <div class="situat_item">
                  <span class="label">设计温度</span>
                  <span class="room_type">{{
                    reporInfo.temperature_max + "℃"
                  }}</span>
                </div>
                <div class="situat_item">
                  <span class="label">设计负荷</span>
                  <span class="room_type">{{
                    "冷" + (Number((sumitem.energy_cold / 1000))/Number(sumitem.area)).toFixed(2) + "kw"
                  }}</span>
                </div>
                <div class="situat_item">
                  <span class="label">设计负荷</span>
                  <span class="room_type">{{
                    "暖" + (Number((sumitem.energy_hot_per / 1000))/Number(sumitem.area)).toFixed(2) + "kw"
                  }}</span>
                </div>
                <div class="situat_item">
                  <span class="label">需求负荷</span>
                  <span class="room_type">{{
                    "冷" + sumitem.energy_cold / 1000 + "kw"
                  }}</span>
                </div>
                <div class="situat_item">
                  <span class="label">需求负荷</span>
                  <span class="room_type">{{
                    "暖" + sumitem.energy_hot / 1000 + "kw"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="onEnd" @click="onEnd">关闭</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bShowEnd: {
      type: Boolean,
      default: false,
    },
    reporInfo: {
      type: Object,
      default: false,
    },
  },
  data() {
    return {
      bAntmain: true, //控制动画播放
      arrEnd: [
        { room: 1, arrShopp: [{ openId: 0, open: true }] },
        { room: 2, arrShopp: [{ openId: 0, open: true }] },
      ],
    };
  },
  filters: {
    roomNumber(index) {
      // console.log("-->计算属性", index);
      let arr = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      if (index < 0) {
        return "地下室" + arr[Number(-index) - 1] + "层";
      } else if (index <= 10 && index > 0) {
        return arr[Number(index) - 1] + "层";
      }
    },
    towards(index) {
      // console.log(index);
      let outiten;
      switch (index) {
        case 0:
          outiten = "南";
          break;
        case 1:
          outiten = "北";
          break;
        case 2:
          outiten = "东";
          break;
        case 3:
          outiten = "西";
          break;
        case 4:
          outiten = '东南';
          break;
        case 5:
          outiten = "西南";
          break;
        case 6:
          outiten = "东北";
          break;
        case 7:
          outiten = "西北";
          break;
        case 9:
          outiten = "无/未知";
          break;
      }
      return outiten;
    },
  },
  methods: {
    getOpen(index, sumindex) {
      for (let i = 0; i < this.reporInfo.sub[index].rooms.length; i++) {
        if (this.reporInfo.sub[index].rooms[i].openId == sumindex) {
          this.reporInfo.sub[index].rooms[i].open = !this.reporInfo.sub[index]
            .rooms[i].open;
        }
        //  else {
        //   this.arrEnd[index].arrShopp[i].open = false;
        // }
      }
    },
    //点击关闭
    onEnd() {
      this.bAntmain = false;
      setTimeout(() => {
        this.bAntmain = true;
        this.$emit("update:bShowEnd", false);
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.onmagin {
  animation: antinpyt 0.5s forwards;
  // transition: all 0.3s;
}
.nomagin {
  animation: noantinpyt 0.5s forwards;
}
.onEnd {
  width: 650px;
  height: 80px;
  background-color: #023f88;
  border-radius: 40px;
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 30px;
}
.conter {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 9999999999;
  background: #fff;
  padding: 20px 15px;
  box-sizing: border-box;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    color: transparent !important;
    display: none;
  }
  .conter_warp {
    width: 100%;
    height: auto;
  }
  .title_xiao {
    margin-top: 30px;
    font-size: 34px;
    font-weight: 700;
    color: #434343;
    display: flex;
    align-items: center;

    &::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 30px;
      background-color: #023f88;
      margin-left: 12px;
      margin-right: 6px;
    }
  }
  .rooms_list {
    width: 100%;
    height: auto;
    margin-top: 40px;
    .room {
      font-size: 30px;
      color: #023f88;
      width: 100%;
      height: 75px;
      background-color: #edf2ff;
      border-radius: 38px;
      display: flex;
      align-items: center;
      padding-left: 80px;
    }
    .shopp_warp {
      margin-top: 34px;
      width: 100%;
      height: auto;
      background-color: #ffffff;
      box-shadow: 0px 0px 24px 0px rgba(168, 207, 251, 0.4);
      border-radius: 16px;
      border: solid 1px #bec9f9;
      box-sizing: border-box;
      overflow: hidden;
      .room_name {
        width: 100%;
        height: 56px;
        background-color: #023f88;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 37px;
        box-sizing: border-box;
        font-size: 30px;
        color: #fff;
        .tips_icon {
          display: flex;
          align-items: center;
          &::after {
            content: "";
            display: inline-block;
            width: 22px;
            height: 14px;
            transform: rotate(-180deg);
            transition: All 0.3s ease-in-out;
            background: url(~@/assets/images/antV2/scheme/bottom_icon.png)
              no-repeat center/100% 100%;
            margin-left: 11px;
          }
        }
        .openClass {
          &::after {
            transform: rotate(0deg);
            transition: All 0.3s ease-in-out;
          }
        }
      }
      .shopp_conter {
        padding: 0 30px;
        box-sizing: border-box;
        .shopp_room_aeit {
          width: 100%;
          padding: 30px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #dde3fc;
          display: flex;
          align-items: center;
          .situat_item {
            width: 50%;
            display: flex;
            align-items: center;
             justify-content: space-between;
             padding-right: 10px;
             box-sizing: border-box;

            .label {
              // width: 88px;
              padding: 0 16px;
              box-sizing: border-box;
              height: 40px;
              background-color: #e9f1fd;
              border-radius: 20px;
              border: solid 1px #aec9ef;
              font-size: 28px;
              color: #023f88;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 20px;
            }

            .room_type {
              // width: 250px;
              font-size: 28px;
              color: #434343;
            }
          }
        }
        .shopp_title {
          font-size: 34px;
          color: #2d2d2d;
          margin-top: 30px;
          font-weight: 700;
        }
        .end_shopp {
          padding: 30px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #dde3fc;
          width: 100%;
          // &:first-child {
          //   border-bottom: 0;
          // }
          .end_shopp_name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 28px;
            color: #2d2d2d;
            .end_type {
              width: 400px;
              text-align: justify;
            }
            div:first-child {
              width: 231px;
            }
          }
          .end_shopp_warp {
            width: 100%;
            display: flex;
            margin-top: 25px;
            align-items: center;
            justify-content: space-between;
            .shopp_img {
              width: 151px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 120px;
              }
            }
            .shopp_attr {
              width: 400px;
              div {
                width: 100%;
                font-size: 28px;
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &:first-child {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
.selection {
  width: 100%;
  height: auto;
  // padding: 0 15px;
  box-sizing: border-box;

  .selection_conter {
    padding: 40px 0;
    box-sizing: border-box;
    border-bottom: 2px solid #e3e7f7;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;

    .situat_item {
      width: 50%;
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 10px;
      box-sizing: border-box;

      .label {
        // width: 88px;
        padding: 0 16px;
        box-sizing: border-box;
        height: 40px;
        background-color: #e9f1fd;
        border-radius: 20px;
        border: solid 1px #aec9ef;
        font-size: 28px;
        color: #023f88;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
      }

      .room_type {
        // width: 250px;
        font-size: 28px;
        color: #434343;
      }
    }
  }
}
.actOpenBorder {
  &:last-child {
    border-bottom: 0 !important;
  }
}
.actOpen {
  display: none;
}
@keyframes antinpyt {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes noantinpyt {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>